import { useInfiniteQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

export type ISearchResults = typeof ApiCatalog.search.mockData;

interface UseInfinateSearchQueryParams {
  urlParams: string | URLSearchParams;
  enabled: boolean;
}

export const useInfiniteSearchQuery = ({
  urlParams,
  enabled,
}: UseInfinateSearchQueryParams) => {
  const sanitizedParams = new URLSearchParams(urlParams);
  // Remove page since the infinite query handles it seperately.
  sanitizedParams.delete("page");

  return useInfiniteQuery({
    initialPageParam: 0,
    getNextPageParam: (lastPage: ISearchResults, allPages) => {
      // Determine next page based on how many total results
      // and how many we current have loaded.
      const currentResultsCount = allPages.reduce(
        (acc, page) => acc + page.results.length,
        0,
      );
      return currentResultsCount < lastPage.total_result_count
        ? allPages.length
        : undefined;
    },
    queryKey: [ApiCatalog.search.key, sanitizedParams.toString()],
    queryFn: ({ pageParam = 0 }) => {
      return api().get(
        `${ApiCatalog.search.endpoint}?page=${pageParam}&${sanitizedParams}`,
      );
    },
    refetchOnWindowFocus: false,
    enabled,
  });
};
